module.exports = __webpack_public_path__ + "posture/static/img/top-bg.3b9b0fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/top-bg.png
// module id = 0gUf
// module chunks = 1